import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './policy.css';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="container">
      <h1 className="container-heading">
        Privacy Policy
      </h1>
      <p>Last updated: March 31st, 2026</p>
      <p>This Privacy Policy outlines how APTO Websites collects, uses, discloses, and protects the personal information of users when you access and use the our website and our services.</p>

      <section className='policy-content'>
        <h2>
          Information we collect
        </h2>
        <div className='policy-content-subtext'>
          <p>
            We may collect the following types of information when you use our Website:
          </p>
          <ul className='policy-content-list'>
            <li>Personal Information: When you access our services, we may collect your name, email address, contact information, and other details you provide.</li>
            <li>Usage Information: We may collect information about your interactions with the Website and the pages or features you access.</li>
          </ul>
        </div>
      </section>

      <section className='policy-content'>
        <h2>
          Use of Information
        </h2>
        <div className='policy-content-subtext'>
          <p>
            We may use the collected information for the following purposes:
          </p>
          <ul className='policy-content-list'>
            <li>To provide and personalize our services, including facilitating user accounts and delivering requested services.</li>
            <li>To communicate with you, respond to inquiries, and provide customer support.</li>
            <li>To improve and optimize the Website's functionality, user experience, and services.</li>
            <li>To analyze usage patterns, monitor trends, and gather statistical information to enhance our services.</li>
            <li>To protect the security and integrity of our Website and prevent fraud or other unauthorized activities.</li>
          </ul>
        </div>
      </section>

      <section className='policy-content'>
        <h2>
          Disclosure of Information
        </h2>
        <div className='policy-content-subtext'>
          <p>
            We may disclose your personal information in the following circumstances:
          </p>
          <ul className='policy-content-list'>
            <li>Service Providers: We may share your information with trusted third-party service providers who assist us in operating the Website and delivering our services. These providers are obligated to protect your information and can only use it for the purposes specified by us.</li>
            <li>Legal Compliance: We may disclose information if required by law, regulation, legal process, or governmental request.</li>
            <li>Protection of Rights: We may disclose information to protect the rights, safety, or property of our users, ourselves, or others.</li>
            <li>Business Transfers: In the event of a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred as part of the transaction, subject to customary confidentiality obligations.</li>
          </ul>
        </div>
      </section>

      <section className='policy-content'>
        <h2>
          Data Retention
        </h2>
        <div className='policy-content-subtext'>
          <p>
            We retain your personal information for as long as necessary to fulfill the purposes outlined in this Policy, unless a longer retention period is required or permitted by law.
          </p>
        </div>
      </section>

      <section className='policy-content'>
        <h2>
          Third-Party Links
        </h2>
        <div className='policy-content-subtext'>
          <p>
            Our Website may contain links to third-party websites or services. We have no control over the privacy practices or content of these third-party websites. We encourage you to review the privacy policies of those websites before providing any personal information.
          </p>
        </div>
      </section>

      <section className='policy-content'>
        <h2>
          Security
        </h2>
        <div className='policy-content-subtext'>
          <p>
            We take reasonable measures to protect the confidentiality, integrity, and security of your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure. We cannot guarantee absolute security, and you acknowledge and accept any associated risks.
          </p>
        </div>
      </section>

      <section className='policy-content'>
        <h2>
          Children's Privacy
        </h2>
        <div className='policy-content-subtext'>
          <p>
            The Website is not intended for individuals under the age of 13. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information without your consent, please contact us to request its removal.
          </p>
        </div>
      </section>

      <section className='policy-content'>
        <h2>
          Your Rights
        </h2>
        <div className='policy-content-subtext'>
          <p>
            You have the right to access, update, correct, or delete your personal information. If you wish to exercise any of these rights, please contact us using the information provided below. We will respond to your request within a reasonable timeframe.
          </p>
        </div>
      </section>

      <section className='policy-content'>
        <h2>
          Changes to the Privacy Policy
        </h2>
        <div className='policy-content-subtext'>
          <p>
            We reserve the right to update or modify this Privacy Policy at any time. We will notify you of any material changes through the Website or by other means. Your continued use of the Website after such modifications will constitute your acknowledgment and acceptance of the updated Policy.
          </p>
        </div>
      </section>

      <section className='policy-content'>
        <h2>
          Contact Us
        </h2>
        <div className='policy-content-subtext'>
          <p>
            If you have any questions regarding this privacy policy, please{" "}
            <Link to="/contact" className="contact-link">
              contact us
            </Link>.
          </p>
        </div>
      </section>

    </div>
  )
}

export default PrivacyPolicy